export function array8(n) { return new Uint8Array(n); }

export function array16(n) { return new Uint16Array(n); }

export function array32(n) { return new Uint32Array(n); }



//////////////////
// WEBPACK FOOTER
// ./~/vega-crossfilter/src/arrays.js
// module id = 787
// module chunks = 0